function addScrollMarginToTarget(scrollTarget, marginAmount = null) {
    if (scrollTarget && scrollTarget.offsetTop < window.scrollY) {
        if (!marginAmount)
            marginAmount = document.querySelector('.toolbar')?.offsetHeight;
        const origMargin = window.getComputedStyle(scrollTarget).scrollMarginTop;
        const origMarginF = parseFloat(origMargin) || 0;
        scrollTarget.style["scroll-margin-top"] = `${marginAmount + origMarginF}px`;
        setTimeout(
            () => {scrollTarget.style["scroll-margin-top"] = ""},
            500
        );
    }
}

function setupToolbar({selector = '.toolbar', hideOnInit = true} = {}) {
    const toolbar = document.querySelector(selector);
    const mainNav = document.getElementById('navWrapper');
    if (!toolbar) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    const threshold = mainNav.offsetHeight;

    const updateToolbar = () => {
        const currentScrollY = window.scrollY;
        const pastThreshold = currentScrollY > threshold;
        const shouldHide = currentScrollY >= lastScrollY && pastThreshold;
        toolbar.classList.toggle('hidden', shouldHide);
        toolbar.classList.toggle('past-threshold', pastThreshold);

        lastScrollY = currentScrollY > 0 ? currentScrollY : 0;
        ticking = false;
    };

    if (hideOnInit) {
        toolbar.classList.add("no-transition");
        // Update right away in case window is reloaded with scroll
        // position lower than top.
        updateToolbar();
        // Trigger reflow
        void toolbar.offsetHeight;
        toolbar.classList.remove("no-transition");
    }

    const updateToolbarThrottled = () => {
        if (!ticking) {
            requestAnimationFrame(updateToolbar);
            ticking = true;
        }
    };
    window.addEventListener('scroll', updateToolbarThrottled);

    function handleFocus() {
        toolbar.classList.add("unhide-on-focus");
        toolbar.classList.remove("hidden");
        // Trigger reflow
        void toolbar.offsetHeight;
        setTimeout(() => {
            toolbar.classList.remove("unhide-on-focus");
        }, 10);
    }

    toolbar.addEventListener('focusin', handleFocus);

    function disableToolbar() {
        window.removeEventListener('scroll', updateToolbarThrottled);
        window.removeEventListener('focusin', handleFocus);
    }
    return disableToolbar
}

export {setupToolbar, addScrollMarginToTarget}
export default setupToolbar
